import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'

export default function Layout() {
  const location = useLocation()
  const isDashboard = location.pathname === '/'

  return (
    <div className="h-[100dvh] flex flex-col bg-surface overflow-hidden">
      <Header isDashboard={isDashboard} />

      <main
        className={
          isDashboard
            ? 'flex-1 overflow-auto bg-gray-50'
            : 'flex-1 overflow-auto w-full px-3 sm:px-6 py-3 sm:py-4 min-h-0'
        }
      >
        <Outlet />
      </main>
    </div>
  )
}
